"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var SERVICE_PREFIX = '/capacity-planning-service/insights';
exports.Routes = {
    GET_INSIGHTS_COUNT: "".concat(SERVICE_PREFIX, "/count"),
    GET_INSIGHTS: "".concat(SERVICE_PREFIX, "/"),
    UPDATE_INSIGHT_DONE: "".concat(SERVICE_PREFIX, "/{:insightId}/done")
};
//# sourceMappingURL=CapacityInsights.consts.js.map